<template>
  <div class="nup_main">
    <div class="new_content">
      <div class="new_webposition">
        <router-link :to="{ path: '/usercenter'}">学习中心</router-link>
        <span class="nje_jiange">&gt;</span><span class="nje_last">我的学分</span></div>
      <div class="nupmrm_case">
        <div class="npm_caseDiv9" style="padding-left: 0px;">
          <div class="npm_caseDiv9_right">
            <el-select v-model="searchForm.year" size="small" style="width:105px; height: 36px;"
              @change="getTrainingNameList()">
              <el-option label="全部年份" value=""></el-option>
              <el-option
                v-for="item in yearReturn"
                :key="item.trainingYear"
                :label="item.year"
                :value="item.year">
              </el-option>
            </el-select>
            <el-select v-model="searchForm.trainingId" size="small" style="width:170px;">
              <el-option label="全部培训班" value=""></el-option>
              <el-option
                v-for="item in nameReturn"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="searchForm.state" size="small" style="width:100px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="未申请学分" value="2"></el-option>
              <el-option label="已申请学分" value="3"></el-option>
            </el-select>
            <el-select v-model="searchForm.projectType" size="small" style="width:100px;">
              <el-option label="项目类别" value=""></el-option>
              <!--<el-option  label="国家级" value="1"></el-option>-->
              <el-option label="省级" value="2"></el-option>
              <el-option label="市级" value="3"></el-option>
              <!--<el-option  label="区/县级" value="4"></el-option>
              <el-option  label="其它" value="5"></el-option>-->
            </el-select>
            <el-select v-model="searchForm.creditType" size="small" style="width:100px;">
              <el-option label="学分类别" value=""></el-option>
              <el-option label="I类" value="6"></el-option>
              <el-option label="II类" value="7"></el-option>
              <!--<el-option  label="其它" value="8"></el-option>-->
            </el-select>
            <el-select v-model="searchForm.credit" size="small" style="width:100px;">
              <el-option label="全部学分" value=""></el-option>
              <el-option label="1" value="1"></el-option>
              <el-option label="2.5" value="2.5"></el-option>
              <el-option label="5" value="5"></el-option>
              <!--<el-option  label="其他" value="6"></el-option>-->
            </el-select>
            <input class="f_r" type="button" value="搜索" @click="searchList"/>
            <el-input v-model="searchForm.trainingName" class="f_r"
              placeholder="按培训名字关键字搜索" size="small" style="display:inline-block;width:200px;"></el-input>
          </div>
        </div>
      </div>
      <div class="nupmrm_content">
        <el-table v-loading="listLoading" :data="scoreListInit" highlight-current-row style="width: 100%;">
          <el-table-column label="培训名称" show-overflow-tooltip width="350">
            <template slot-scope="scope">
              <font v-show="scope.row.type == 0" style="color:#1D7A8E">[继教]</font>{{ scope.row.projectName }}
            </template>
          </el-table-column>
          <el-table-column label="项目类别" prop="projectType" width="100"></el-table-column>
          <el-table-column
            label="项目编号"
            prop="projectCode"
            width="150"
          ></el-table-column>
          <el-table-column label="学分类别" prop="creditType" width="100"></el-table-column>
          <el-table-column label="学分" prop="creditValue" width="70"></el-table-column>
          <el-table-column label="学习状态" prop="state" width="100"></el-table-column>
          <el-table-column :context="_self" label="操作" width="90">
            <template slot-scope="scope">
              <a v-if="scope.row.state=='已申请学分'" class="k7" href="javascript:"
                title="取消申请" @click="cancelApplyScore(scope.$index, scope.row)">&nbsp;</a>
              <a v-else-if="scope.row.state=='已授予学分'" class="k7" href="javascript:" title="申请学分"
                @click="alreadyGrant">&nbsp;</a>
              <a v-else class="k8" href="javascript:" title="申请学分" @click="applyScore(scope.$index, scope.row)">&nbsp;</a>
            </template>
          </el-table-column>
          <el-table-column label="证书编号" width="190">
            <template slot-scope="scope">
              <div @click="showQrCode(scope.row)">
                {{ scope.row.certificat }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar" style="padding-top: 12px;">
          <el-pagination :current-page="searchForm.currentPage" :page-size="searchForm.pageSize"
            :total="searchForm.total" layout="total, prev, pager, next" style="float:right;"
            @current-change="handleExamCurrentChange">
          </el-pagination>
        </el-col>
      </div>
    </div>
    <el-dialog :visible.sync="qrCodeVisible" style="text-align: center" title="二维码" width="30%">
      <img :src="qrUrl"/>
    </el-dialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import CryptoJS from 'crypto-js'
import jsonp from 'jsonp'

import {
  applyCredit,
  calcelApplyCredit,
  getMyScoreList,
  getMyScoreTrainingName,
  getMyScoreTrainingYear,
  getUserTrainingExam
} from '../../api/api'

export default {
  data() {
    return {
      yearReturn: [],
      nameReturn: [],
      scoreListInit: [],
      qrCodeVisible: false,
      qrUrl: '',
      listLoading: false,
      searchForm: {
        currentPage: 1,//当前页数
        pageSize: 10,//每页显示条目个数
        total: 0, //总条目数
        year: '',
        trainingId: '',
        state: '',
        projectType: '',
        creditType: '',
        credit: '',
        trainingName: '',
        userId: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    
    showQrCode(row) {
      var date = null
      if (row.applyTime) {
        date = new Date(row.applyTime.replace(new RegExp('-', 'gm'), '/'))
      }
      var rawStr = 'https://source.yiboshi.com/statichtml/StudentCertificate.html?cno=' + row.certificat + '&uname=' + row.realName + '&pname=' + row.projectName + '&ptype=' + row.projectType + '&ctype=' + row.creditType + '&score=' + row.creditValue + '&creddate=' + date + '&ou=' + row.orgName + '&dep=' + row.departmentName
      var wordArray = CryptoJS.enc.Utf8.parse(rawStr)
      var base64 = CryptoJS.enc.Base64.stringify(wordArray)
      
      if (row.certificat != '-') {
        this.qrUrl = process.env.API_URL + '/img/qr?size=3&qr=' + encodeURIComponent(base64)
        this.qrCodeVisible = true
      } else {
        this.$message({
          type: 'info',
          message: '暂无证书！'
        })
      }
    },
    
    hideQrCode() {
      this.qrCodeVisible = false
    },
    
    searchList() {
      this.searchForm.currentPage = 1
      this.listScoreInit()
    },
    alreadyGrant() {
      this.$alert('已授予学分，不能取消申请！', '提示', {
        confirmButtonText: '确定',
        type: 'error'
      })
    },
    listScoreInit() {
      if (this.$storejs.get(process.env.APPKEY + 'token') == undefined) {
        this.$alert('请刷新检查登陆状态', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/')
          }
        })
        return false
      }
      this.listLoading = true
      getMyScoreList({...this.searchForm, source: 'shiyan'}).then((res) => {
        this.searchForm.total = res.data.data.total
        this.scoreListInit = res.data.data.list
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$message({
          type: 'info',
          message: '加载失败！'
        })
      })
    },
    getTrainingYearList() {
      var param = {userId: this.userInfo.id}
      getMyScoreTrainingYear(param).then((response) => {
        this.yearReturn = response.data.data.list
      }).catch((error) => {
      })
    },
    
    getTrainingNameList() {
      this.searchForm.trainingId = ''
      var param = {userId: this.userInfo.id, year: this.searchForm.year, source: 'shiyan'}
      if (this.searchForm.year != '') {
        getMyScoreTrainingName(param).then((response) => {
          this.nameReturn = response.data.data.list
        }).catch((error) => {
        })
      } else {
        this.nameReturn = []
      }
      
    },
    
    handleExamCurrentChange(val) {
      this.searchForm.currentPage = val
      this.listScoreInit()
    },
    doApply(trainingId, projectId) {
      this.$confirm('是否确定申请此项目学分?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        applyCredit({
          trainingId: trainingId,
          projectId: projectId,
          userId: this.userInfo.id
        }).then((response) => {
          this.listLoading = false
          if (response.data.status == 1) {
            this.$alert(response.data.info, '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                this.listScoreInit()
              }
            })
          } else {
            if (response.data.info == '人员信息在本省学分管理平台不存在，请下载继教通APP进行注册'
              || response.data.info == '人员信息与本省学分管理平台不一致，请核实修改') {
              this.$alert('<div style="text-align:center;font-size:13px;">' +
                '<p style="padding-bottom:25px;">' + response.data.info + '</p>' +
                '<img src="https://source.yiboshi.com/public/img/%E7%BB%A7%E6%95%99%E9%80%9AAPP%E4%B8%8B%E8%BD%BD.gif">' +
                '<p style="color:#9A9A9A;font-size:12px;">手机扫一扫下载继教通客户端</p>', '提示', {
                dangerouslyUseHTMLString: true
              })
            } else {
              this.$alert(response.data.info, '提示', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {
                }
              })
            }
          }
        })
      }).catch(() => {
        /*this.$message({
         type: 'warning',
         message: '申请失败'
         });*/
      })
    },
    applyScore(index, row) {
      var trainingId = row.trainingId
      var creditCateggory = row.creditType
      var creditSetting = row.creditValue
      var projectId = row.projId
      var creditApplyCondition = row.creditApplyCondition
      if (this.readOnly == true) {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      } else {
        if (!creditCateggory || creditCateggory == '' || creditCateggory == null || creditCateggory == '0' ||
          !creditSetting || creditSetting == '' || creditSetting == null || creditSetting == '0') {
          this.$alert('该项目在您所在地区尚未开展，您暂不能申请学分！', '提示', {
            confirmButtonText: '确定'
          })
        } else {
          //非继教培训查询考试是否及格
          if (projectId == '' && creditApplyCondition > 0) {
            getUserTrainingExam({
              userId: this.userInfo.id,
              trainingId: trainingId
            }).then((response) => {
              if (response.data.status == 200) {
                var trainingExam = response.data.data.trainingExam
                var param = ''
                for (var i = 0; i < trainingExam.length; i++) {
                  param += 'examId[]=' + trainingExam[i].examId + '&'
                }
                if (param != '') {
                  param = param.substr(0, param.length - 1)
                  jsonp(process.env.EXAM_API_URL + '/v1/user/' + this.userInfo.id + '/exam/score?' + param
                    , (err, data) => {
                      var exams = data.data
                      for (var k = 0; k < exams.length; k++) {
                        if ((exams[k].score == null && exams[k].passingScore > 0) || exams[k].score < exams[k].passingScore) {
                          this.$alert('结业考试成绩未合格，请点击<a href=\'/MyExam\' target=\'_blank\' style=\'color: #0D9AB5\'>我的考试</a >查看！', '提示', {
                            confirmButtonText: '确定',
                            type: 'error',
                            dangerouslyUseHTMLString: true
                          })
                          return false
                        } else {
                          this.doApply(trainingId, projectId)
                        }
                      }
                    })
                } else {
                  this.doApply(trainingId, projectId)
                }
              }
            })
          } else {
            this.doApply(trainingId, projectId)
          }
          
        }
      }
    },
    cancelApplyScore(index, row) {
      var trainingId = row.trainingId
      var projectId = row.projId
      if (this.readOnly == true) {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      } else {
        this.$confirm('确认要取消申请学分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          calcelApplyCredit({
            trainingId: trainingId,
            projectId: projectId,
            userId: this.userInfo.id
          }).then((response) => {
            if (response.data.status == 1) {
              this.$alert(response.data.info, '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  this.listScoreInit()
                }
              })
            } else {
              this.$alert(response.data.info, '提示', {
                confirmButtonText: '确定',
                type: 'error'
              })
            }
          })
        }).catch(() => {
          /*this.$message({
           type: 'warning',
           message: '取消申请失败'
           });*/
        })
      }
    },
    
    viewDetail(index, row) {
      if (row.type == 0) {
        this.$router.push({
          path: '/usercenter/projectDtail',
          query: {trainingId: row.trainingId, projectId: row.projId}
        })
      } else if (row.type != 0) {
        this.$router.push({path: '/usercenter', query: {trainingId: row.trainingId}})
      }
    }
    
  },
  mounted() {
    this.getTrainingYearList()
    this.searchForm.userId = this.userInfo.id
    this.listScoreInit()
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/usercenter/MyScore.vue